import React, { FC } from 'react';
import { Button, Drawer } from 'antd';

interface IComponentProps {
  open: boolean;
  content: string;
  subtitle: string;
  confirmBtnTitle: string;
  cancelBtnTitle?: string;
  loading?: boolean;
  onClose?: () => void;
  onConfirm: () => void;
}

export const WarningCard: FC<IComponentProps> = ({
  open,
  subtitle,
  content,
  confirmBtnTitle,
  cancelBtnTitle = 'Отмена',
  loading,
  onClose,
  onConfirm,
}) => {
  const handleClose = () => {
    if (loading) {
      return;
    }

    onClose?.();
  };

  return (
    <Drawer rootClassName="redesign drawer warning-card" open={open} onClose={handleClose} width={720} destroyOnClose>
      <div className="drawer__body">
        <div className="drawer__title">{content}</div>

        <span className="text-h3 color-dark-grey">{subtitle}</span>
      </div>

      <div className="drawer__footer">
        <Button className="button-lg danger" onClick={onConfirm} loading={loading}>
          {confirmBtnTitle}
        </Button>

        <Button className="button-lg secondary" onClick={handleClose} loading={loading}>
          {cancelBtnTitle}
        </Button>
      </div>
    </Drawer>
  );
};
